import { EquipmentDemobiliationStateTypes, EquipmentDemobiliationActionTypes } from "./EquipmentDemobiliation.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EquipmentDemobiliationStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EquipmentDemobiliationReducer = (
  state: EquipmentDemobiliationStateTypes = INITIAL_STATE,
  action: any
): EquipmentDemobiliationStateTypes => {
  switch (action.type) {
    case EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EquipmentDemobiliationReducer;
